import { Component, inject, OnInit, viewChild } from "@angular/core";
import { Router } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";

import { AdaaHelper } from "../../../../core/utils";
import { DataTableComponent } from "../../../../shared/components";
import { Constants } from "../../../../shared/constants/constants";
import { TableActionEvent } from "../../../../shared/models";
import { SystemLayoutService } from "../../../../shared/services";

@Component({
  selector: "adaa-forecasted-values-kpis-list",
  imports: [TranslatePipe, DataTableComponent],
  templateUrl: "./forecasted-values-kpis-list.html",
  styleUrl: "./forecasted-values-kpis-list.scss",
})
export class ForecastedValuesKpisListComponent implements OnInit {
  private readonly _router = inject(Router);
  private readonly _systemLayoutService = inject(SystemLayoutService);

  datatable = viewChild.required<DataTableComponent>("adaaDataTable");

  private readonly _untilDestroy = AdaaHelper.untilDestroyed();

  Constants = Constants;

  public ngOnInit(): void {
    this._systemLayoutService.hasActiveEntityChanged$.pipe(this._untilDestroy()).subscribe({
      next: () => this.datatable().loadTableData(true),
    });

    this._systemLayoutService.hasCycleChanged$.pipe(this._untilDestroy()).subscribe({
      next: () => this.datatable().loadTableData(true),
    });
  }

  public actionClicked(event: TableActionEvent): void {
    this._router.navigateByUrl(`console/forecasted-values/kpis/edit/${event.data.kpiId}`);
  }
}
